export function JavascriptIcon({ className }: { className?: string }) {
    return (
      <svg
        className={className}
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="56" height="56" rx="0" fill="#F7DF1E" />
        <path
          d="M33.629 43.691C34.438 44.996 35.438 46.004 37.297 46.004C38.82 46.004 39.738 45.242 39.738 44.145C39.738 42.859 38.656 42.422 36.941 41.648L36.047 41.262C33.148 39.984 31.219 38.395 31.219 35.352C31.219 32.543 33.359 30.406 36.906 30.406C39.422 30.406 41.273 31.277 42.52 33.403L39.41 35.387C38.754 34.262 38.047 33.828 36.906 33.828C35.738 33.828 35.039 34.527 35.039 35.387C35.039 36.484 35.746 36.922 37.379 37.637L38.273 38.023C41.625 39.457 43.555 40.988 43.555 44.121C43.555 47.309 41.059 49.477 37.379 49.477C33.813 49.477 31.68 47.625 30.602 45.488L33.629 43.691ZM19.844 44C20.559 45.27 21.508 46.145 23.234 46.145C24.688 46.145 25.516 45.488 25.516 43.93V30.555H29.336V44.004C29.336 47.645 27.227 49.477 23.484 49.477C20.047 49.477 17.941 47.637 16.891 45.488L19.844 44Z"
          fill="black"
        />
      </svg>
    );
  }
  